import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import { useForm } from 'react-hook-form';
import { GridForm } from 'components/Ui/styled';
import { PaperProps, userSuccess } from 'constants';
import { useSelector, useDispatch } from 'react-redux';
import { getUser, putUser } from 'layouts/users/services/userApis';
import { FormInputSwitch } from 'components/Common/Forms/FormInputSwitch';
import { setEmployeeDetails } from 'layouts/documentManagement/store/employeeDetailsSlice/employeeDetailsSlice';
import {
  getDialogHeading,
  renderSaveCancelButtons,
  onSave,
  emptyFunction,
  refinePayload,
  useNotification,
} from 'utils/commonUtils';
import { setIsActiveCompanyAssociation } from 'layouts/documentManagement/store/employeeDocumentsFilterSlice/employeeDocumentsFilterSlice';

const ActiveCompanyAssociationsDialog = (props) => {
  const {
    activeCompanyAssociationsDialog,
    setActiveCompanyAssociationsDialog,
    company,
  } = props;

  const dispatch = useDispatch();

  const {
    setOpenNotification,
    setNotificationMessage,
    handleErrorResponse,
    NotificationPopup,
  } = useNotification();

  const [loadingButton, setLoadingButton] = useState(false);

  const employeeDetails = useSelector((state) => state.employeeDetails);

  const { activeCompanyAssociations, username } = employeeDetails || {};

  const { delta, k3, ies } = activeCompanyAssociations || {};

  const defaultValue = {
    delta: delta,
    k3: k3,
    ies: ies,
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
  });

  const { handleSubmit, control, reset } = useFunction;

  useEffect(() => {
    reset(defaultValue);
  }, [defaultValue.delta, defaultValue.k3, defaultValue.ies]);

  const handleClose = () => {
    setActiveCompanyAssociationsDialog(false);
  };

  const fetchEmployee = async () => {
    try {
      const employeeDetails = await getUser(username);
      dispatch(setEmployeeDetails(employeeDetails?.user));
      dispatch(
        setIsActiveCompanyAssociation(
          !!employeeDetails?.user?.activeCompanyAssociations?.[company]
        )
      );
    } catch (error) {
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  const onSubmit = (data) => {
    const payload = {
      activeCompanyAssociations: data,
    };

    onSave(
      userSuccess,
      false,
      emptyFunction,
      putUser,
      refinePayload(payload),
      username,
      fetchEmployee,
      handleClose,
      setOpenNotification,
      setNotificationMessage,
      dispatch,
      setLoadingButton,
      loadingButton
    );
  };

  return (
    <>
      <Dialog open={activeCompanyAssociationsDialog} PaperProps={PaperProps}>
        {getDialogHeading('Active Company Associations', handleClose)}
        <GridForm container spacing={2}>
          <Grid item xs={12}>
            <FormInputSwitch
              name="delta"
              label="Delta"
              control={control}
              checked={defaultValue.delta}
            />
            <FormInputSwitch
              name="k3"
              label="K3"
              control={control}
              checked={defaultValue.k3}
            />
            <FormInputSwitch
              name="ies"
              label="IES"
              control={control}
              checked={defaultValue.ies}
            />
            {renderSaveCancelButtons(
              handleClose,
              handleSubmit(onSubmit),
              loadingButton
            )}
          </Grid>
        </GridForm>
      </Dialog>
      <NotificationPopup />
    </>
  );
};

export default ActiveCompanyAssociationsDialog;
